import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '../../models/product-models';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  private cartItemsSubject: BehaviorSubject<Product[]> = new BehaviorSubject<Product[]>([]);
  cartItems$: Observable<Product[]> = this.cartItemsSubject.asObservable();

  constructor() {
    // Load cart items from local storage if available
    const storedCartItems = localStorage.getItem('cartItems');
    if (storedCartItems) {
      this.cartItemsSubject.next(JSON.parse(storedCartItems));
    }
  }

  getProducts(): Observable<Product[]> {
    return this.cartItems$;
  }

  addProductToCart(product: Product): void {
    const currentItems = this.cartItemsSubject.value;
    this.cartItemsSubject.next([...currentItems, product]);
    this.updateLocalStorage();
  }

  removeCartItem(product: Product): void {
    const currentItems = this.cartItemsSubject.value.filter(item => item.item_SKU !== product.item_SKU);
    this.cartItemsSubject.next(currentItems);
    this.updateLocalStorage();
  }

  removeAllCart(): void {
    this.cartItemsSubject.next([]);
    this.updateLocalStorage();
  }

  private updateLocalStorage(): void {
    localStorage.setItem('cartItems', JSON.stringify(this.cartItemsSubject.value));
  }
}


